import styled, { css } from 'styled-components';

interface ImageProps {
  $fullWidth?: boolean;
}

export const Image = styled.img.withConfig({ componentId: 'sc-13p0maa-0' })<ImageProps>`
    display: block;
    max-width: 100%;

    ${({ $fullWidth }) =>
      $fullWidth &&
      css`
            width: 100%;
        `}
`;
